import Api from '@/api'
// import { isEmpty } from 'lodash'
// import Request from '@/models/Request'

/** @param {object} filters */
function buildFileRequestedFiltersQuery(filters) {
  const qs = []
  if (filters.status != null && Array.isArray(filters.status)) {
    qs.push(`filter[status]=${encodeURIComponent(filters.status.join(','))}`)
  }
  const search = filters.search != null ? String(filters.search).trim() : ''
  const ownedBy = filters.ownedBy != null ? String(filters.ownedBy).trim() : ''
  if (search) {
    qs.push(`filter[search]=${encodeURIComponent(search)}`)
  } else {
    qs.push(`filter[user]=${encodeURIComponent(ownedBy)}`)
  }
  return qs.length ? `&${qs.join('&')}` : ''
}

export default {
  namespaced: true,

  state: {
    requests: [],
    requestsMeta: null,
    request: null,
    fileRequest: null,
  },

  mutations: {
    setRequests(state, requests) {
      state.requests = requests
    },

    setRequestsMeta(state, meta) {
      state.requestsMeta = meta
    },

    clearRequests(state) {
      state.requests = []
    },

    setRequest(state, request) {
      state.request = request
    },

    clearRequest(state) {
      state.request = null
    },

    setFileRequest(state, fileRequest) {
      state.fileRequest = fileRequest
    },

    clearFileRequest(state, fileRequest) {
      state.fileRequest = null
    },
  },

  actions: {
    async getRequestedBy({ commit }, { page = 1, limit = 10, filters = null }) {
      commit('clearRequests')

      let url = `file-requested-by?page=${page}&limit=${limit}`

      if (filters) {
        url += buildFileRequestedFiltersQuery(filters)
      }

      await new Promise(async (resolve, reject) => {
        await Api.get(url)
          .then((res) => {
            if (res.data) {
              commit('setRequests', res.data.data)
              commit('setRequestsMeta', res.data.meta)

              resolve(res.data.data)
            }
          })
          .catch((err) => {
            reject(err.response)
          })
      })
    },

    async getRequestedTo({ commit }, { page = 1, limit = 10, filters = null }) {
      commit('clearRequests')

      let url = `file-requested-to?page=${page}&limit=${limit}`

      if (filters) {
        url += buildFileRequestedFiltersQuery(filters)
      }

      await new Promise(async (resolve, reject) => {
        await Api.get(url)
          .then((res) => {
            if (res.data.data) {
              commit('setRequests', res.data.data)
              commit('setRequestsMeta', res.data.meta)

              resolve(res.data.data)
            }
          })
          .catch((err) => {
            reject(err.response)
          })
      })
    },

    async getRequest({ commit }, id) {
      commit('clearRequest')

      await new Promise(async (resolve, reject) => {
        await Api.get(`file-request/${id}`)
          .then((res) => {
            if (res.data.data) {
              commit('setRequest', res.data.data)

              resolve(res.data.data)
            }
          })
          .catch((err) => {
            reject(err.response)
          })
      })
    },

    async getRequestByUser({ commit }, id) {
      commit('clearRequest')

      await new Promise(async (resolve, reject) => {
        await Api.get(`file-request-users/${id}`)
          .then((res) => {
            if (res.data.data) {
              commit('setRequest', res.data.data)

              resolve(res.data.data)
            }
          })
          .catch((err) => {
            reject(err.response)
          })
      })
    },

    async deleteRequest({ commit }, id) {
      await new Promise(async (resolve, reject) => {
        await Api.delete(`file-request/${id}`)
          .then((res) => {
            commit('clearRequest')

            resolve(res.data)
          })
          .catch((err) => {
            reject(err.response)
          })
      })
    },

    async fileRequestShare({ commit }, formData) {
      await new Promise(async (resolve, reject) => {
        await Api.post(`file-request/${formData.fileRequestId}/share`, formData)
          .then((res) => {
            commit('clearRequest')

            resolve(res.data)
          })
          .catch((err) => {
            reject(err.response)
          })
      })
    },
  },

  getters: {
    requests(state) {
      return state.requests
    },

    requestsMeta(state) {
      return state.requestsMeta
    },

    request(state) {
      return state.request
    },

    fileRequest(state) {
      return state.fileRequest
    },
  },
}
